module.exports = __webpack_public_path__ + "static/parade-2020-house09-398ef645cad1399d7b10c04fbcd5abff.jpg";